import { render, staticRenderFns } from "./OcoOrderInfoModal.html?vue&type=template&id=206a1821&scoped=true&"
import script from "./OcoOrderInfoModal.js?vue&type=script&lang=js&"
export * from "./OcoOrderInfoModal.js?vue&type=script&lang=js&"
import style0 from "./OcoOrderInfoModal.scss?vue&type=style&index=0&id=206a1821&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206a1821",
  null
  
)

export default component.exports